import { Component, Inject, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WalletSetupService } from '../../services/api/wallet-setup.service';

@Component({
  selector: 'app-modal-tnc-next-gen',
  templateUrl: './modal-tnc-next-gen.component.html',
  styleUrls: ['./modal-tnc-next-gen.component.scss']
})
export class ModalTncNextGenComponent {
  agreeTermA: boolean = false;
  agreeTermB: boolean = false;

  // Flag to toggle between T&C text and Confirmation screen
  showConfirmation: boolean = false;
  isSubmitting: boolean = false;

  @Output() accept = new EventEmitter<void>();
  @Output() decline = new EventEmitter<void>();

    constructor(
    private walletSetupService: WalletSetupService
    ){}

    onAccept(event: MouseEvent): void{

      const button = event.currentTarget as HTMLButtonElement;
          if (button) {
            button.disabled = true;
          }

      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.accept.emit();
      console.log('onAccept clicked');
   //   let sessionID=sessionStorage.getItem("SessionID");

    }

    // 2. Called when user clicks "No Thanks" (Switches view, does NOT emit yet)
  onInitialDecline(): void {
    this.showConfirmation = true;
  }

  // 3. Called when user clicks "Back to Rewards" (Goes back to T&C)
  onBackToRewards(): void {
    this.showConfirmation = false;
  }

  // 4. Called when user clicks "Yes, I'm sure" (Actually logs out)
  onFinalDecline(): void {
    this.decline.emit();
  }

    onDecline(): void{
      this.decline.emit();
    }

    canAccept(): boolean {
      return this.agreeTermA && this.agreeTermB;
    }
}
